import React from 'react';
import ChartSelectCondition from '../chart-line-components/ChartLine';

interface Props {}

const ChartCorrelation: React.FC<Props> = () => {
  return (
    <div>
      <ChartSelectCondition />
    </div>
  );
};

export default ChartCorrelation;
